import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';

@Component({
    selector: 'app-calculator-input',
    templateUrl: './calculator-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./calculator-input.component.scss'],
})
export class CalculatorInputComponent {
    @Input() value = '';
    @Input() disabled = false;
    @Output() enter = new EventEmitter<void>();

    // ตัวแปรเก็บสถานะว่า "รอการคำนวณ" หรือไม่
    isPending = false;

    onInput(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        let sanitizedValue = inputElement.value.replace(/[^0-9.]/g, '');

        const parts = sanitizedValue.split('.');
        if (parts.length > 1) {
            sanitizedValue = parts[0] + '.' + parts[1].substring(0, 2);
        }

        inputElement.value = sanitizedValue;
        this.value = sanitizedValue;
        this.isPending = true;
    }

    onEnter(event: Event): void {
        event.preventDefault();
        if (!this.disabled) {
            const inputElement = event.target as HTMLInputElement;
            inputElement.focus();
            this.enter.emit();
            inputElement.blur();
        }
    }

    onBlur(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        const rawValue = inputElement.value;
        if (rawValue !== '') {
            const numericValue = parseFloat(rawValue);
            if (!isNaN(numericValue)) {
                const formattedValue = numericValue.toFixed(2);
                this.value = formattedValue;
                inputElement.value = formattedValue;
            }
        }
    }

    onEsc(event: Event): void {
        event.preventDefault();
        if (!this.disabled) {
            this.value = '';
        }
    }

    // ฟังก์ชันนี้เตรียมไว้ให้ Component แม่เรียกใช้เมื่อคำนวณผลลัพธ์เสร็จแล้ว
    public markAsCalculated(): void {
        this.isPending = false;
    }
}
